import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import Icon from "./icon";
import Button from "./button";

var PageHeader = function PageHeader(_ref) {
  var image = _ref.image,
      title = _ref.title,
      subtitle = _ref.subtitle,
      _ref$breadcrumbs = _ref.breadcrumbs,
      breadcrumbs = _ref$breadcrumbs === void 0 ? [] : _ref$breadcrumbs,
      actions = _ref.actions,
      onBackClick = _ref.onBackClick,
      className = _ref.className;
  //Needs this to handle a small css margin tweak for the back button
  var hasBreadCrumbsAndImage = breadcrumbs.length > 0 && image;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("et--page-header", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "et--page-header-content-wrap"
  }, onBackClick && /*#__PURE__*/React.createElement(Button, {
    className: classNames("et--page-header--back", {
      "with-image-crumbs": hasBreadCrumbsAndImage
    }),
    type: "simple",
    onClick: onBackClick,
    title: "Go back"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-left",
    size: 2
  })), /*#__PURE__*/React.createElement("div", null, breadcrumbs.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "et--page-header-breadcrumbs"
  }, breadcrumbs.map(function (crumb, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: crumb
    }, crumb, index === 0 && breadcrumbs.length !== 1 || index !== breadcrumbs.length - 1 ? /*#__PURE__*/React.createElement("span", {
      className: "et--page-header-breadcrumbs-separator"
    }, ">") : null);
  })), /*#__PURE__*/React.createElement("div", {
    className: "et--page-header-title-content"
  }, image && /*#__PURE__*/React.createElement("div", {
    className: "et--page-header--image"
  }, image), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    tabIndex: -1
  }, title), subtitle && /*#__PURE__*/React.createElement("div", {
    className: "et--page-header--subtitle"
  }, subtitle))))), actions && /*#__PURE__*/React.createElement("div", {
    className: "et--page-header--actions"
  }, actions));
};

PageHeader.propTypes = {
  image: PropTypes.any,
  title: PropTypes.any,
  subtitle: PropTypes.node,
  breadcrumbs: PropTypes.array,
  actions: PropTypes.node,
  onBackClick: PropTypes.func,
  className: PropTypes.string
};
export default PageHeader;